module.exports = __webpack_public_path__ + "img/18.c6e0fe10.jpg";